import { registerPlugin } from '@capacitor/core';

import { MNTokenPlugin } from './definitions';
import { CAPACITOR_MN_TOKEN_PLUGIN_NAME } from '../pluginConstants';

const MNToken = registerPlugin<MNTokenPlugin>(CAPACITOR_MN_TOKEN_PLUGIN_NAME);

export { MNToken };
